window.module = {};
var ModalDialogManager = require('components/modal-dialog/manager/modal-dialog-manager').default;
var AlertDialog = require('components/modal-dialog/message/alert/alert-dialog').default;
var ConfirmationDialog = require('components/modal-dialog/message/confirmation/confirmation-dialog').default;
var TextDialog = require('components/modal-dialog/input/text/text-dialog').default;
var NumberDialog = require('components/modal-dialog/input/number/number-dialog').default;
var BooleanDialog = require('components/modal-dialog/input/boolean/boolean-dialog').default;
var DateTimeDialog = require('components/modal-dialog/input/date-time/date-time-dialog').default;
var ModalDialogWaitBackdrop = require('components/modal-dialog/wait-backdrop/modal-dialog-wait-backdrop').default;

window.JSZip = require('jszip');


// Styles
// CAUTION  Since the app styles may overwrite component styles (which may, for
// instance, stem from npm packages), please make sure components are _not_
// required after the following statement (to make sure app.scss is able to
// overwrite component styles entirely):
require('./app.scss');

// jQuery & Bootstrap
var jQuery = require('jquery');
jQuery.browser = {}; // since jquery-migrate 3 does nothing to add this
window.jQuery = jQuery;
window.$ = jQuery;

require('jquery-migrate');
require('bootstrap'); // bootstrap javascript for animating styles

var jQueryUi = require('jquery-ui');
console.log('jQuery UI', jQueryUi);

// for jQuery UI 1.12.1:
require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/button');
require('jquery-ui/ui/widgets/dialog');

require('jqwidgets-framework/jqwidgets/jqxcore');
require('jqwidgets-framework/jqwidgets/globalization/globalize');
require('jqwidgets-framework/jqwidgets/jqxdraw');
require('jqwidgets-framework/jqwidgets/jqxbuttons');
require('jqwidgets-framework/jqwidgets/jqxswitchbutton');
require('jqwidgets-framework/jqwidgets/jqxknob');
require('jqwidgets-framework/jqwidgets/jqxprogressbar');
require('jqwidgets-framework/jqwidgets/jqxslider');
require('jqwidgets-framework/jqwidgets/jqxcalendar');
require('jqwidgets-framework/jqwidgets/jqxdatetimeinput');
require('jqwidgets-framework/jqwidgets/jqxnotification');
require('jqwidgets-framework/jqwidgets/jqxtooltip');
require('jqwidgets-framework/jqwidgets/jqxscrollbar');
require('jqwidgets-framework/jqwidgets/jqxdata');
require('jqwidgets-framework/jqwidgets/jqxlistbox');
require('jqwidgets-framework/jqwidgets/jqxdropdownlist');

require('howler');

require('signalr');

let QRCode = require('qrcode');
window.QRCode = QRCode;
// Dialogs

var dialogs = {};

// dialog manager
dialogs.Manager = ModalDialogManager; // class
dialogs.manager = new ModalDialogManager(); // instance

// dialog implementations
dialogs.AlertDialog = AlertDialog;
dialogs.ConfirmationDialog = ConfirmationDialog;
dialogs.TextDialog = TextDialog;
dialogs.NumberDialog = NumberDialog;
dialogs.BooleanDialog = BooleanDialog;
dialogs.DateTimeDialog = DateTimeDialog;

// wait backdrop (optional)
dialogs.ModalDialogWaitBackdrop = ModalDialogWaitBackdrop; // class
dialogs.waitBackdrop = new ModalDialogWaitBackdrop(); // instance

// make dialogs globally accessible for legacy code
window.dialogs = dialogs;

// make moment globally accessible for legacy code
var moment = require('moment');
window.moment = moment;
var is = require('is_js');
window.is = is;
